import { api } from "../../api/axios";
import type {
  TAccessToLessonRequest,
  TAccessToLessonVideoRequest,
  TSeasonChapterRequest,
  TSeasonRequest,
  TUserLesson,
} from "../types";

export const getSeasons = async (params: TSeasonRequest["payload"]) => {
  const { data } = await api.get<TSeasonRequest["response"]>(
    `/v1/user/chapters/webinar/${params.webinarId}`
  );

  return data;
};

export const getSeasonChapters = async (
  params: TSeasonChapterRequest["payload"]
) => {
  const { data } = await api.get<TSeasonChapterRequest["response"]>(
    `/v1/user/chapters/${params.chapterId}/lessons`
  );

  return data;
};

export const getUserLessons = async () => {
  const { data } = await api.get<TUserLesson[]>(`/v1/users/me/lessons`);
  return data;
};

export const accessToLesson = async (
  params: TAccessToLessonRequest["payload"]
) => {
  const { data } = await api.post<TAccessToLessonRequest["response"]>(
    `/v1/users/me/lessons/${params.lessonId}/enroll`
  );
  return data;
};

export const accessToLessonVideo = async (
  params: TAccessToLessonVideoRequest["payload"]
) => {
  const { data } = await api.get<TAccessToLessonVideoRequest["response"]>(
    `/v1/users/me/lessons/${params.lessonId}/videos`
  );
  return data;
};
